export default function objectKeysToLowerCase(obj) {
    if (!obj)
        return obj;
    return Object.keys(obj)
        .reduce(function (acc, key) {
        acc[key.toLowerCase()] = obj[key];
        return acc;
    }, {});
}
//# sourceMappingURL=objectKeysToLowerCase.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/misc/objectKeysToLowerCase.js
// module id = 15
// module chunks = 1